module.exports = __webpack_public_path__ + "img/Finnie.77e25fea.svg";